export const RANGE_TYPE_OPTIONS = [
  { id: 'day',   label: 'range_type_day' },
  { id: 'week',  label: 'range_type_week' },
  { id: 'month', label: 'range_type_month' },
  { id: 'year',  label: 'range_type_year' },
];

export const MAX_DELTA: { [ unitType in ( 'day' | 'week' | 'month' | 'year' ) ]: number } = {
  'day': 365,
  'week': 106,
  'month': 48,
  'year': 10,
};

export const IMPORT_MODE = {
  IGNORE: 'ignore',
  OVERRIDE: 'override',
  UNDEFINED: undefined
};